import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";

// Importando os componentes das novas pastas
import Login from "./pages/Login";
import Menu from "./pages/Menu";
import Admin from "./pages/Admin";
import Eventos from "./pages/Eventos";
import { clearAuth, getAuthToken, isTokenUsable } from "./utils/auth";

// Componente para verificar autenticação
const ProtectedRoute = ({ children }) => {
  const token = getAuthToken();
  if (!isTokenUsable(token)) {
    clearAuth();
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  useEffect(() => {
    document.title = "EU VOU P14 SPORTS";
  }, []);
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* <Route path="/menu" element={<ProtectedRoute></ProtectedRoute>} /> */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Menu />
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route path="/eventos" element={<Eventos />} />
          <Route path="/" element={<Navigate to="/eventos" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
